module.exports = __webpack_public_path__ + "static/media/Nikhil-Kamath.b2823a3a.png";